// Functionality for menu link expansion

(function ($, Drupal, once) {

    Drupal.behaviors.casMainMenu = {
      attach(context) {
        const menu = once('casMainMenu', '#cas__main-nav', context);
        if ($(menu).is($('#cas__main-nav'))) {
            const collapsibleMenu = once('casMainMenu', '#nav-bottom', context);
            const menuToggle = once('casMainMenu', '#menu-toggle-row', context)
            const minWidth = window.matchMedia('(min-width: 900px)');
            const $menuHide = $(menuToggle).bind('click', (e) => {
                $(collapsibleMenu).toggleClass('menu--open');
                $(menu).toggleClass('cas__main-nav--open');
                e.preventDefault();
            });
            //cleanup classes in case someone resizes with the menu open
            $(window).resize(function () {
                if (!minWidth.matches && $(collapsibleMenu).hasClass('menu--open')) {
                    $(menuToggle).click();
                }
            });
            window.addEventListener('click', function(e){   
                if ($(collapsibleMenu).hasClass('menu--open') &&
                    !(
                        (document.getElementById('nav-bottom').contains(e.target)) || (document.getElementsByClassName('cas-header')[0].contains(e.target))
                    )
                ) {
                    console.log("clicked outside");
                    $(menuToggle).click();
                }
            });
        }
      },
    };

  })(jQuery, Drupal, once);

  // function to move top menu on media query and toggle menu classes for mobile styles
  (function ($, Drupal) {

    Drupal.behaviors.mainMenuMobile = {
      attach(context) {
        const topNav = $("#block-topnavigation", context);
        const menu = $('#cas__main-nav', context);
        const minWidth = window.matchMedia('(min-width: 900px)');
        if (minWidth.matches) {
            if (menu.hasClass('cas__main-nav--mobile')) {
                menu.removeClass('cas__main-nav--mobile');
                topNav.appendTo($('.cas-header')[0]);
            }
        }
        else if (!menu.hasClass('cas__main-nav--mobile')) {
                menu.addClass('cas__main-nav--mobile');
                topNav.appendTo($('#nav-bottom'));
        }
  
        $(window).resize(function () {
            if (minWidth.matches) {
                if (menu.hasClass('cas__main-nav--mobile')) {
                    menu.removeClass('cas__main-nav--mobile');
                    topNav.prependTo($('.cas-header')[0]);
                }
            }
            else if (!menu.hasClass('cas__main-nav--mobile')) {
                    menu.addClass('cas__main-nav--mobile');
                    topNav.appendTo($('#nav-bottom'));
            }
        });
  
        if (menu.is($('#cas__main-nav'))) {
          const toggleExpand = $('.cas__toggle-expand', context);
  
          // Mobile Menu Show/Hide.
          const menuHide = once('mainMenuMobile', '.cas__toggle-expand', context);
          const $menuHide = $(menuHide).bind('click', (e) => {
          //toggleExpand.once('mainMenuMobile').bind('click', (e) => {
            toggleExpand.toggleClass('toggle-expand--open');
            menu.toggleClass('cas__main-nav--open');
            e.preventDefault();
          });
        }
      },
    };
    // eslint-disable-next-line no-undef
  })(jQuery, Drupal, once);
  